import React, { useEffect, useState } from 'react'
import Breadcrum from '../../components/breadcrum'
import CompanyCard from '../../components/companyCard'
import BannerImage from '../../components/BannerImage'
import { Link } from 'react-router-dom'
import { FaPlus, FaSearch } from 'react-icons/fa'
import { useQuery } from '@tanstack/react-query'
import { getAllDeals } from '../../api/dealsApi'
import toast from 'react-hot-toast'

const Growth = () => {
  useEffect(() => {
    document.title = 'Growth'
  }, [])

  const [searchTerm, setSearchTerm] = useState('')

  const {
    data: growthData = [],
    isLoading,
    isError,
  } = useQuery({
    queryKey: ['growth'],
    queryFn: () => getAllDeals('growth'),
    isError: (error) => {
      toast.error('Errro While fetching growth')
    },
  })

  const filteredUsers =
    growthData?.filter((growth) => {
      const matchesSearch =
        growth.brandName?.toLowerCase().includes(searchTerm.toLowerCase()) ||
        growth.writtenBy?.toLowerCase().includes(searchTerm.toLowerCase())

      let matchesMonth = false
      if (growth.createdAt) {
        const date = new Date(growth.createdAt)
        const monthName = date
          .toLocaleDateString('default', {
            month: 'long',
          })
          .toLowerCase()
        matchesMonth = monthName.includes(searchTerm.toLowerCase())
      }

      return matchesSearch || matchesMonth
    }) || []

  const total = growthData?.length || 0

  if (isLoading) {
    return (
      <>
        <Breadcrum heading="Deal" subheading="Growth" />
        <div className="text-center py-8">Loading growth...</div>
      </>
    )
  }

  if (isError) {
    return (
      <>
        <Breadcrum heading="Deal" subheading="Growth" />
        <div className="text-center py-8 text-red-500">
          Error loading Growth. Please try again later.
        </div>
      </>
    )
  }

  return (
    <>
      <Breadcrum heading="Deal" subheading="Growth" />
      <BannerImage bannerId={3} />

      <div className="bg-gray-100 sm:w-[90%] mx-auto mt-5 rounded-lg shadow-inner">
        <div className="bg-white rounded-md shadow-md p-6 flex justify-center">
          <Link
            to="/dealdashboard/add/growth"
            className="text-xl p-2 rounded-full bg-[#ff7010] text-white"
            title="Add New"
          >
            <FaPlus />
          </Link>
        </div>
      </div>

      <div className="flex flex-wrap gap-4 justify-between mt-6 w-[90%] m-auto">
        <div className="fixed right-10 top-[18%] bg-[#ff7010] rounded-full text-white text-xl w-fit h-fit px-3 py-1 shadow-md">
          {total}
        </div>

        {/* Search and Filter Section */}
        <div className="w-full mx-auto my-6">
          <div className="bg-white rounded-xl p-6 shadow-md border border-gray-100">
            <div className="flex flex-col md:flex-row gap-4">
              <div className="flex-1 relative">
                <FaSearch className="absolute left-4 top-1/2 transform -translate-y-1/2 text-gray-400 w-4 h-4" />
                <input
                  type="text"
                  placeholder="Search by company name or writter name or created month"
                  value={searchTerm}
                  onChange={(e) => setSearchTerm(e.target.value)}
                  className="w-full pl-12 pr-4 py-3 border border-gray-200 rounded-lg focus:ring-2 focus:ring-[#ff7010] focus:border-transparent outline-none transition-all"
                />
              </div>
            </div>
            <div className="mt-4 text-sm text-gray-500">
              Showing {filteredUsers.length} of {growthData.length} Articles
            </div>
          </div>
        </div>

        <CompanyCard data={filteredUsers} edit="growth" />
      </div>
      <div className="bg-gray-100 sm:w-[90%] mx-auto mt-5 rounded-lg shadow-inner">
        <div className="bg-white rounded-md shadow-md p-6 flex justify-center">
          <Link
            to="/dealdashboard/add/growth"
            className="text-xl p-2 rounded-full bg-[#ff7010] text-white"
            title="Add New"
          >
            <FaPlus />
          </Link>
        </div>
      </div>
    </>
  )
}

export default Growth
